module.exports = __webpack_public_path__ + "media/images/about_solution-pic2-fbd806d1.png";